<template>
    
</template>

<script>
    export default {
        name: "SliderMixin",
        methods: {
            setSliderDisplay (eventData) {
                this.changeMyData({
                    showSlider: !eventData.value
                })
                this.setChangesAreSaved(false);
            },
            getSliderDisplay () {
                return this.myData.showSlider;
            },
            createSlider () {
                window["slider_" + this.componentId] = new pagesNavigation($(this.myNode.querySelector(".js-render-wrapper")), "slider_" + this.componentId, {
                    buttons: 1,
                    bullets: 1
                }, true, true, true);
            },
            destroySlider () {
                if (window["slider_" + this.componentId]) {
                    window["slider_" + this.componentId].destroy();
                }
            },
            removeSliderNodes (node) {
                //we dont want to destroy the actual slider but we also dont want to save the DOM that it created
                let sliders = node.querySelectorAll(".bulletswrapper");

                for (let index in sliders) {
                    if (!sliders.hasOwnProperty(index)) {
                        continue;
                    }

                    sliders[index].remove();
                }
            }
        }
    }
</script>

